import React, { useState } from 'react';
import {
  PrevConfContainer,
  PrevConfHeading,
  PrevConfHeadingMobile,
  ConferenceSectionContainer,
  ConferenceSection,
  ConferenceHeading,
  ConferenceYear,
  ConferenceName,
  MobileConferenceName,
  LearnMoreButton,
  ButtonLabel,
  LearnMoreCaption,
  SiteLink,
} from './PrevConferences.style';
import { MarginContainer } from '../../lib/shared';
import { motion } from 'framer-motion';

const PrevConferences = ({ conferenceInfo }) => {
  const {
    conference_info: {
      document: {
        data: {
          prev_conferences_title: prevConfTitle,
          conference_list: confList,
        },
        id: id,
      },
    },
  } = conferenceInfo;

  const renderConferenceNameHeading = ({ conf_info }) => {
    const confName = conf_info.conference_name.text;
    const confNameArray = confName.split(' ');
    const interventionsMobileHeadingTop = confNameArray[0]
      .slice(0, 5)
      .concat('-');
    const interventionsMobileHeadingBottom = confNameArray[0].slice(5);

    return (
      <>
        <ConferenceName>{conf_info.conference_name.text}</ConferenceName>
        <MobileConferenceName>
          {interventionsMobileHeadingTop}
          {interventionsMobileHeadingBottom} <br />
          {confNameArray[1]}
        </MobileConferenceName>
      </>
    );
  };

  const renderPrevConfHeading = ({ prevConfTitle }) => {
    const title = prevConfTitle.text;
    const titleArray = title.split(' ');
    const prevConfHeadingTop = titleArray[2].slice(0, 6).concat('-');
    const prevConfHeadingBottom = titleArray[2].slice(6);

    return (
      <>
        <MarginContainer>
          <PrevConfHeading>{title}</PrevConfHeading>
          <PrevConfHeadingMobile>
            {titleArray[0]} <br />
            {titleArray[1]} <br />
            {prevConfHeadingTop} <br />
            {prevConfHeadingBottom}
          </PrevConfHeadingMobile>
        </MarginContainer>
      </>
    );
  };

  const [hoverSection, setHover] = useState(-1);
  const revList = confList.slice().reverse();

  return (
    <PrevConfContainer>
      {renderPrevConfHeading({ prevConfTitle })}
      <ConferenceSectionContainer>
        {revList.map(conf_info => (
          <ConferenceSection
            onMouseEnter={() => setHover(revList.indexOf(conf_info))}
            onMouseLeave={() => setHover(-1)}
            colorMode={hoverSection}
          >
            <MarginContainer>
              <ConferenceHeading>
                <ConferenceYear>
                  {conf_info.conference_year.text}
                </ConferenceYear>
                {renderConferenceNameHeading({ conf_info })}
              </ConferenceHeading>
              <SiteLink href={conf_info.conference_link.url} target="_blank">
                {hoverSection == revList.indexOf(conf_info) && (
                  <LearnMoreCaption
                    as={motion.div}
                    whileHover={{ rotate: -6 }}
                    inputColor={hoverSection}
                  >
                    learn more →
                  </LearnMoreCaption>
                )}
                <LearnMoreButton
                  href={conf_info.conference_link.url}
                  target="_blank"
                >
                  <ButtonLabel>learn more →</ButtonLabel>
                </LearnMoreButton>
              </SiteLink>
            </MarginContainer>
          </ConferenceSection>
        ))}
      </ConferenceSectionContainer>
    </PrevConfContainer>
  );
};

export default PrevConferences;
